import React, { PropsWithChildren, ReactNode, useState } from 'react';
import { Button, SxProps } from '@mui/material';
import ContextMenu from '../ContextMenu/ContextMenu';
import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { headingFontBold, vars } from '../../../Theme';

/** Styles for the button. */
const buttonSx: SxProps = {
    color: vars.white,
    ...headingFontBold,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    p: 1.5,
    height: '40px',
    textTransform: 'capitalize',
    '&:hover': {
        backgroundColor: vars.selectedHoveredGreen,
    },
};

export default ({ title, icon, sx = {}, variant, children }: IDropdownMenuProps) => {
    /** State slice for controlling the position of the button's menu. */
    const [anchorEl, setAnchorEl] = useState<HTMLElement>(null);

    /**
     * Closes the context menu.
     */
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    /**
     * Makes the context menu visible.
     */
    const handleClick = (e: React.MouseEvent) => {
        setAnchorEl(e.currentTarget as HTMLElement);
    };

    return (
        <>
            <Button
                variant={variant ?? 'contained'}
                sx={{ ...buttonSx, ...sx }}
                disableRipple
                onClick={handleClick}
                startIcon={icon ? <Icon path={icon} size={1} /> : null}
                endIcon={<Icon path={anchorEl ? mdiChevronUp : mdiChevronDown} size={1} />}
            >
                {title}
            </Button>

            <ContextMenu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={handleCloseMenu}
                onClick={handleCloseMenu}
                keepMounted
                marginThreshold={8}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {children}
            </ContextMenu>
        </>
    );
};

interface IDropdownMenuProps extends PropsWithChildren {
    title: string;
    children: ReactNode;

    /** Defines icon for the Button component. */
    icon?: string;
    sx?: SxProps;
    variant?: 'outlined' | 'contained';
}
